export default __webpack_public_path__ + "static/media/M.cc4c4aaf.svg";